export default __webpack_public_path__ + "static/media/eye-closed-white.21aad244.svg";